import axios from 'axios'

export const getMaterialRequests = (params) => {
  return axios.get('/finance/materialRequests', { params })
}

export const getMaterialRequest = (id) => {
  return axios.get(`/finance/materialRequests/${id}`)
}

export const getMaterialRequestLog = ({ id, params } = {}) => {
  return axios.get(`/finance/materialRequests/${id}/logs`, { params })
}

export const addMaterialRequest = (data) => {
  return axios.post('/finance/materialRequests', data)
}

export const updateMaterialRequest = ({ id, data }) => {
  return axios.put(`/finance/materialRequests/${id}`, data)
}

export const deleteMaterialRequest = (id) => {
  return axios.delete(`/finance/materialRequests/${id}`)
}

export const inputMassDeleteMaterialRequest = (data) => {
  return axios.post('/finance/materialRequests/inputMassDelete', data)
}

export const executeMassDeleteMaterialRequest = (data) => {
  return axios.delete('/finance/materialRequests/executeMassDelete', { data })
}

export const submitMaterialRequest = (id) => {
  return axios.post(`/finance/materialRequests/${id}/submit`)
}

export const approveMaterialRequest = (id) => {
  return axios.post(`/finance/materialRequests/${id}/approve`)
}

export const rejectMaterialRequest = ({ id, body }) => {
  return axios.post(`/finance/materialRequests/${id}/reject`, body)
}

export const revertApprovalMaterialRequest = (id) => {
  return axios.post(`/finance/materialRequests/${id}/revert`)
}

export const revertToDraftMaterialRequest = (id) => {
  return axios.post(`/finance/materialRequests/${id}/draft`)
}

export const cancelMaterialRequest = (id) => {
  return axios.post(`/finance/materialRequests/${id}/cancel`)
}

export const deleteOnAddMaterialRequestAttachment = (url) => {
  return axios.delete('/finance/materialRequests/attachments', { data: { url } })
}

export const deleteOnEditMaterialRequestAttachment = (id, url) => {
  return axios.delete(`/finance/materialRequests/${id}/attachments`, { data: { url } })
}
